define('modules/common/controller/ModalChangePasswordController',[], function() {
	var Controller = function(
		$scope,
		$modalInstance,
		LoadingHandler,
		CambiaPassword,
		toaster,
		CredenzialiUtente,
		DatiCliente
		) {

		$scope.force = true;
		DatiCliente.mustChangePassword().then(function(force){
			if (!force) {
				$scope.force = false;
			}
		});	

		$scope.closeModal = function() {
			$modalInstance.dismiss();
		};

		$scope.form = {
			oldpassword:"",
			newpassword: "",
			newpassword2: ""
		};
		$scope.erroreOldPass = false;
		$scope.erroreNewPass = false;
		$scope.erroreNew2Pass = false;

		$scope.confrontaPass = function() {
			if ($scope.form.newpassword2 !== $scope.form.newpassword) {
				$scope.erroreNew2Pass = true;
			} else {
				$scope.erroreNew2Pass = false;
			}
		};

		$scope.salva = function(){
			if (!$scope.form.oldpassword) {
				$scope.erroreOldPass = true;
			} else {
				$scope.erroreOldPass = false;
			}

			if (!$scope.form.newpassword) {
				$scope.erroreNewPass = true;
			} else {
				$scope.erroreNewPass = false;
			}

			$scope.confrontaPass();

			if (!$scope.erroreOldPass && !$scope.erroreNewPass && !$scope.erroreNew2Pass) {
				LoadingHandler.start();
				CambiaPassword($scope.form).then(function(result) {
					toaster.pop({
						body:"La password è stata modificata con successo"
					});
					CredenzialiUtente.setPassword($scope.form.newpassword);
					DatiCliente.reset();
					$modalInstance.close();
					LoadingHandler.stop();
				}, function(error) {
					console.log(error);
					var errorMsg = error.data.esito[0].causaerrore || "Si è verificato un errore nella modifica della password";
					toaster.pop({
						type: "error",
						body: errorMsg
					});
					LoadingHandler.stop();
				});
				
			}
			
		};

	};

	return [
		"$scope",
		"$modalInstance", 
		"LoadingHandler",
		"CambiaPassword",
		"toaster",
		"CredenzialiUtente",
		"DatiCliente",
		Controller
	];
});
